import React from "react";

import {
  ProductCardDataType,
  VerticalProductCard as ProductCard
} from "../components/index";

type Props = {
  productCardData: ProductCardDataType;
  onButtonClick?: () => void;
  onShadeSelectorClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  onWishlistToggle?: (productCardData: ProductCardDataType) => void;
  onCardClick?: (event: React.MouseEvent<HTMLAnchorElement>) => void;
  buttonVariant?: "primary" | "secondary";
};

// Carousel variant without Badge and Ribbon components
export const CarouselVerticalProductCard = ({
  productCardData,
  onButtonClick,
  onShadeSelectorClick,
  onWishlistToggle,
  onCardClick,
  buttonVariant
}: Props) => {
  return (
    <ProductCard product={productCardData} onClick={onCardClick}>
      <ProductCard.Header>
        <ProductCard.Image product={productCardData} />
        {onWishlistToggle && (
          <ProductCard.Wishlist
            product={productCardData}
            onToggle={onWishlistToggle}
          />
        )}
      </ProductCard.Header>

      <ProductCard.Body>
        <ProductCard.Rating product={productCardData} />
        <ProductCard.BrandName product={productCardData} />
        <ProductCard.ProductName product={productCardData} />
        <ProductCard.Pricing product={productCardData} />
        {(productCardData.swatchImages?.length ?? 0) > 0 && (
          <ProductCard.ColorSwatch
            product={productCardData}
            onClick={onShadeSelectorClick}
          />
        )}
      </ProductCard.Body>

      <ProductCard.Footer>
        {onButtonClick && (
          <ProductCard.Button
            product={productCardData}
            onClick={onButtonClick}
            variant={buttonVariant}
          />
        )}
      </ProductCard.Footer>
    </ProductCard>
  );
};
